var globalhome = {
    heroTitleTop:"Welcome to",
    heroTitleMain:"Marival",
    heroTitleMainAccent:"for Agents",
    heroSuccessTitle:"Your Success Is Our Priority",
    heroSuccessText:"Everything you need to confidently sell Marival Resorts, increase your commissions, reward your loyalty, and deliver unforgettable vacations—all in one place.",

    resortsTitle:"Discover Our Resorts",
    perfectForLabel:"Perfect For:",
    closeLabel:"Close",

    resort1Name:"Marival Emotions Resort & Suites Riviera Nayarit by Mercure",
    resort1Tagline:"Fun. Energy. Family Memories.",
    resort1Desc:"A vibrant all-inclusive resort where every generation comes together to create unforgettable memories. Spacious accommodations, endless activities, entertainment, and exceptional value make Emotions the perfect choice for active family vacations.",
    resort1PerfectFor:["Families","Multi-generational travel","Active vacations","Weddings","Great value"],

    resort2Name:"Marival Distinct All-Suites & World Spa – Handwritten Collection",
    resort2Tagline:"Space. Comfort. Elevated Experiences.",
    resort2Desc:"An upscale all-inclusive experience offering luxurious residences, personalized service, exclusive amenities, and refined dining. Designed for families and groups seeking extra space, comfort, and a more sophisticated vacation.",
    resort2PerfectFor:["Luxury families","Family reunions","Small groups","Multi-generational travel","Premium all-inclusive travelers","Weddings"],

    resort3Name:"Armony Marival Resort & Spa Punta de Mita – MGallery Collection",
    resort3Tagline:"Nature. Wellness. Serenity.",
    resort3Desc:"A peaceful beachfront retreat where wellness, nature, and relaxation take center stage. Families reconnect through immersive experiences while adults enjoy dedicated adults-only spaces designed for complete tranquility.",
    resort3PerfectFor:["Wellness travelers","Couples","Luxury seekers","Relaxed family escapes","Weddings"],

    promiseEyebrow:"The Marival Promise",
    promiseTitle:"Three Distinct Resorts. One Exceptional Promise.",
    promiseIntro:"For more than 40 years, Marival Resorts has been welcoming guests with genuine Mexican hospitality while delivering exceptional all-inclusive experiences in the heart of Riviera Nayarit, just minutes from authentic Puerto Vallarta.",
    promise1Name:"Family-Owned & Locally Rooted",
    promise1Text:"Proudly family-owned since 1985, deeply committed to our destination, community, and authentic hospitality.",
    promise2Name:"Masters of All Inclusive",
    promise2Text:"More than four decades of expertise delivering exceptional service, culinary excellence, and memorable guest experiences.",
    promise3Name:"Exceptional Beach Experience",
    promise3Text:"Beautiful Pacific beaches, swimmable shoreline, and unforgettable moments by the sea."
}
module.exports = globalhome
